// import React, { useState, useEffect } from 'react';
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import axiosInstance from '../axiosConfig';
// import { useNavigate, useParams } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowAltCircleLeft, faArrowAltCircleRight, faArrowLeft, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';


// const LiveTracking = () => {
//     const { id } = useParams(); 
//   const [userLocations, setUserLocations] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [activeRole, setActiveRole] = useState(null);
//   const [isSidebarVisible, setIsSidebarVisible] = useState(false);
//   const [error, setError] = useState('');
//   const navigate = useNavigate();
//   const [userData, setUserData] = useState(null);
//   const currentUserId = localStorage.getItem('id');
//   const [loading, setLoading] = useState(true);


//     useEffect(() => {
//       const screenWidth = window.innerWidth;
//       if (screenWidth < 520) { 
//         setIsSidebarVisible(false);
//       } else {
//         setIsSidebarVisible(true);
//       }
//     }, []);
  
//   const handleToggleClick = () => {
//     setIsSidebarVisible(!isSidebarVisible);
//   };

//   useEffect(() => {
//     if (currentUserId) {
//       axiosInstance.get(`/user/${currentUserId}/`)
//         .then((response) => {
//           setUserData(response.data);
//         })
//         .catch((error) => {
//           console.error('Error fetching data:', error);
//           setLoading(false);
//         });
//     }
//   }, [currentUserId, id]); 
  

//   useEffect(() => {
//     const fetchLocations = async () => {
//       try {
//         const response = await axiosInstance.get('/location/live/all/');
//         setUserLocations(response.data);
//       } catch (error) {
//         console.error("Error fetching live locations:", error);
//       }
//     };

//     fetchLocations();
//     const interval = setInterval(fetchLocations, 5000); // Refresh every 5 seconds
//     return () => clearInterval(interval);
//   }, []);

//   const handleSwitchRole = async () => {
//     try {
//       const response = await axiosInstance.post('/switch-role/', { role_id: roles[1].id });
//       // alert(`Active role switched to: Employee`);
//       setActiveRole(roles[1]);
//       navigate('/user-dashboard');
//     } catch (err) {
//       if (err.response?.data.detail === "You do not have permission to switch roles.") {
//         setError("You don't have another role to switch to.");
//       } else {
//         console.error('Failed to switch role:', err.response?.data.detail);
//       }
//     }
//   };

//   const handleLogout = () => {
//     axiosInstance.post('/logout/', { refresh: localStorage.getItem('refresh') })
//       .then(response => {
//         localStorage.removeItem('accessToken');
//         localStorage.removeItem('refreshToken');
//         localStorage.removeItem('employee_code');
//         localStorage.removeItem('assignedRole');
//         localStorage.removeItem('id'); 
//         window.location.href = '/';
//       })
//       .catch(error => {
//         console.error(error);
//       });
//   };

//   const handleToggleSidebar = () => {
//     setIsSidebarVisible(!isSidebarVisible);
//     const sidebar = document.querySelector('.sidebar');
//     sidebar.classList.toggle('visible'); 
//   };

//   return (
//     <div className='tracker-container'>
//      <div className={`sidebar ${isSidebarVisible ? 'visible' : 'hidden'}`}>
//            <h2>{userData?.isAdmin ? 'Admin' : `Welcome: ${userData?.first_name}`}</h2>
//            <ul>
//              {/* <h6 className='role'>Active Role: {activeRole?.name}</h6> */}
//              <li><a href="/admin-manager-lead-dashboard"><i className="fas fa-home" /> Dashboard</a></li>
//                {/* <li><a href={`/profile/${userData?.id}`}><i className="fas fa-user-circle" /> My Profile</a></li> */}
//                <li><a href="/all-requests"><i className="fas fa-file-alt" /> AR Requests</a></li>
//                  <li><a href="/calendar"><i className="fas fa-calendar" /> Calendar</a></li>
//                  {userData?.role_name === 'admin' || userData?.role_name === 'manager' ? (
//                    <>
//                      <li><a href='/employees'><i className='fas fa-user' />Employees</a></li>
//                      <li><a href="/roles-office"><i className="fas fa-id-badge" /> Roles & Office</a></li>
//                    </>
//                  ) : null}
//                  <li className="logout-btn" onClick={() => handleLogout()}><i className="fas fa-sign-out-alt"></i> Logout</li>
//            </ul>
//          </div>
//          <FontAwesomeIcon 
//                icon={isSidebarVisible ? faArrowAltCircleLeft : faArrowAltCircleRight} 
//                className="toggle-sidebar-icon-on" 
//                onClick={handleToggleClick} 
//              />
//              <div className="tracker-content">
//       <h2>Live User Tracking</h2>
//       <MapContainer  center={[28.6139, 77.2090]} zoom={12} style={{ height: "500px", width: "100%" }}>
//         <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//         {userLocations.map((user, index) => (
//           <Marker key={index} position={[user.latitude, user.longitude]}>
//             <Popup>{user.name} - Last seen: {user.timestamp}</Popup>
//           </Marker>
//         ))}
//       </MapContainer>
//       </div>
//     </div>
//   );
// };

// export default LiveTracking;

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../axiosConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faArrowAltCircleRight, faArrowLeft, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import LiveLocationTracker from "../Components/LiveLocationTracker";
import LiveLocationMap from "../Components/LiveLocationMap";

const LiveTracking = () => {
      const { id } = useParams(); 
      const [userData, setUserData] = useState(null);
      const currentUserId = localStorage.getItem('id');
      const [loading, setLoading] = useState(true);
      const [isSidebarVisible, setIsSidebarVisible] = useState(false);
      const [showPopup, setShowPopup] = useState(false);
      const [latitude, setLatitude] = useState('');
      const [longitude, setLongitude] = useState('');
      const [users, setUsers] = useState([]);
      const [selectedUser , setSelectedUser ] = useState(null);
      const [error, setError] = useState('');
      const [liveLocationMap, setLiveLocationMap] = useState(null);

    
      useEffect(() => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 520) { // adjust the breakpoint as needed
          setIsSidebarVisible(false);
        } else {
          setIsSidebarVisible(true);
        }
      }, []);
    
      // your toggle button click handler
      const handleToggleClick = () => {
        setIsSidebarVisible(!isSidebarVisible);
      };

    useEffect(() => {
        if (currentUserId) {
          axiosInstance.get(`/user/${currentUserId}/`)
            .then((response) => {
              setUserData(response.data);
            })
            .catch((error) => {
              console.error('Error fetching data:', error);
              setLoading(false);
            });
        }
      }, [currentUserId, id]); 

    const handleLogout = () => {
        axiosInstance.post('/logout/', { refresh: localStorage.getItem('refresh') })
          .then(response => {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('employee_code');
            localStorage.removeItem('assignedRole');
            localStorage.removeItem('id'); 
            window.location.href = '/';
          })
          .catch(error => {
            console.error(error);
          });
      }; 

    const handleToggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
        const sidebar = document.querySelector('.sidebar');
        sidebar.classList.toggle('visible'); 
      };

      // useEffect(() => {
      //   axiosInstance.get('/location/live/all/')
      //     .then(response => {
      //       setUsers(response.data);
      //     })
      //     .catch(error => {
      //       console.error(error);
      //     });
      // }, []);

      useEffect(() => {
        axiosInstance.get('/user/')
          .then(response => {
            setUsers(response.data);
          })
          .catch(error => {
            console.error(error);
          });
      }, []);

      const handleUpdateLocation = () => {
        axiosInstance.post('/location/live/update/', {
            latitude: latitude,
            longitude: longitude,
            user_id: selectedUser  ,
        })
        .then(response => {
            setShowPopup(false);
            setError('');
            setLatitude('');
            setLongitude('');
            if (liveLocationMap) {
                liveLocationMap.fetchLiveLocations();
            }
        })
        .catch(error => {
            setError(error.response.data.error);
        });
    };
      
    return (
        <div className="dashboard-container">
            <div className={`sidebar ${isSidebarVisible ? 'visible' : 'hidden'}`}>
                  <h2>{userData?.isAdmin ? 'Admin' : `Welcome: ${userData?.first_name}`}</h2>
                  <ul>
                    {/* <h6 className='role'>Active Role: {activeRole?.name}</h6> */}
                    <li><a href="/admin-manager-lead-dashboard"><i className="fas fa-home" /> Dashboard</a></li>
                      {/* <li><a href={`/profile/${userData?.id}`}><i className="fas fa-user-circle" /> My Profile</a></li> */}
                      <li><a href="/all-requests"><i className="fas fa-file-alt" /> AR Requests</a></li>
                        <li><a href="/calendar"><i className="fas fa-calendar" /> Calendar</a></li>
                        {userData?.role_name === 'admin' || userData?.role_name === 'manager' ? (
                          <>
                            <li><a href='/employees'><i className='fas fa-user' />Employees</a></li>
                            <li><a href="/roles-office"><i className="fas fa-id-badge" /> Roles & Office</a></li>
                          </>
                        ) : null}
                        <li className="logout-btn" onClick={() => handleLogout()}><i className="fas fa-sign-out-alt"></i> Logout</li>
                  </ul>
                </div>
                <FontAwesomeIcon 
                      icon={isSidebarVisible ? faArrowAltCircleLeft : faArrowAltCircleRight} 
                      className="toggle-sidebar-icon-on" 
                      onClick={handleToggleClick} 
                    />
            <div className="tracker-content">
        <h2><i class="fa fa-map-marker"></i> Live User Tracking</h2>
        <LiveLocationTracker />
        <LiveLocationMap />
        {/*<button className="query-btn"  onClick={() => setShowPopup(true)}>Update Live Location</button>
         {showPopup && (
          <div className="popup">
            <div className="popup-content">
            <div className="popup-header">
        <h2>Live Location</h2>
        <FontAwesomeIcon 
          icon={faTimes} 
          className="close-popup-icon" 
          onClick={() => setShowPopup(false)} 
        />
      </div>

      <select className='live-user' value={selectedUser  } onChange={(e) => setSelectedUser  (e.target.value)}>
  <option value="">Select User</option>
  {users.map(user => (
    <option key={user.id} value={isNaN(user.id) ? "" : user.id}>{user.first_name} {user.last_name} ({user.employee_code})</option>
  ))}
</select>
            <input type="text" value={latitude} onChange={(e) => setLatitude(e.target.value)} placeholder="Latitude" />
            <input type="text" value={longitude} onChange={(e) => setLongitude(e.target.value)} placeholder="Longitude" />
            <button onClick={handleUpdateLocation}>Submit</button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </div>
          </div>
        )} */}
      </div>
        </div>
    );
};

export default LiveTracking;
